export default {
	duration: 500
}
